import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { withViewModelService, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';

import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withValidation, validationPropTypes } from '@xengage/gw-portals-validation-react';
import { CreditCardUtil } from '@xengage/gw-portals-util-js';
import { TranslatorContext } from '@jutro/locale';
import { AccountBillingDetailsService as BillingService } from 'gw-capability-billing';
import { withRouter } from 'react-router-dom';
import { Icon, ModalNextContext, withModalContext } from '@jutro/components';
import { LoaderExt } from 'gw-components-platform-react';
import PaymentStyles from './PaymentComponentExt.module.scss';
import metadata from './PaymentComponentExt.metadata.json5';
import messages from './PaymentComponentExt.messages';
import BluePay from "./BluePay";


import { Link } from '@jutro/router';


class PaymentComponentExt extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        model: PropTypes.shape({
            paymentMethod: PropTypes.string,
            bankAccountData: PropTypes.shape({}),
            creditCardData: PropTypes.shape({})
        }),
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        onCallback: PropTypes.func.isRequired,
        xCenter: PropTypes.string.isRequired,
        title: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        hideTitle: PropTypes.bool,
        onCancel: PropTypes.func.isRequired,
        nextLabel: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        previousLabel: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        isSetupPayment: PropTypes.bool,
        isCustomFooter: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isSelectedInvoiceAmount: PropTypes.bool,
        intl: PropTypes.func.isRequired,
        ...validationPropTypes
    };

    static defaultProps = {
        model: undefined,
        title: undefined,
        hideTitle: false,
        nextLabel: undefined,
        previousLabel: undefined,
        isSetupPayment: false,
        isCustomFooter: false,
        isDisabled: false,
        showHideDropDown:undefined,
        isSelectedInvoiceAmount: false
    }

    state = {
        paymentMethod: '',
        accountCreditCardVM: {},
        accountBankDetailVM: {},
        showValidationErrors: false,
        selectedradiobutton:'',
        abavalid:false,
        continuevalid:false,
        accountNumbervalid:false,
        checkboxEnabled:false,
        amountDue:0,
        otherAmount:null,
        setreadonly:false,
        setDropdown:'showdropdown',
        showmatchwarningMsg:false,
        isLoading:false,
        dropDownVisibility:' ',
        showHideDropDown:false,
        amountValue:0,
        newSelectedRadioButton:'',
        accountDropdownFlag:false,
        payNowFlag:false,
        bluePayFlag:false,
        
    };

    componentDidMount = () => {
        this.basicDetails()
    };

    basicDetails=()=>{
        let { accountCreditCardVM, accountBankDetailVM } = this.state;        
        const { viewModelService, xCenter, model } = this.props;
        const initValue = {
            paymentMethod: '',
            bankAccountData: {},
            creditCardData: {}, 
        };
        if(this.props.dueAmount>0)
        {
            this.setState({
                selectedradiobutton:"amount Due"
            })
        }
        else{
            this.setState({
                selectedradiobutton:"other"
            })
        }
        
        const ModalNext = React.createContext(ModalNextContext);
        const mergedModel = Object.assign({}, initValue, model);
        const { creditCardData: cardDetailsModel } = mergedModel;
        const { bankAccountData: bankDetailsModel } = mergedModel;
        let { paymentMethod } = mergedModel;
        if (Object.keys(cardDetailsModel).length > 0) {
            paymentMethod = 'creditcard';
        } else {
            paymentMethod = 'wire';
        }


        accountCreditCardVM = viewModelService.create(
            cardDetailsModel,
            xCenter,
            'edge.capabilities.billing.dto.AccountCreditCardDTO'
        );
        accountBankDetailVM = viewModelService.create(
            bankDetailsModel,
            xCenter,
            'edge.capabilities.billing.dto.AccountBankDetailsDTO'
        );
        this.setState({
            paymentMethod,
            accountCreditCardVM,
            accountBankDetailVM,

        });  
    }

    isModelValid = (viewModel) => {
        return viewModel.aspects
            ? viewModel.aspects.valid && viewModel.aspects.subtreeValid
            : false;
    };

  
   
    handlePaymentOptions = (data) => {
        
        this.setState({
            paymentMethod: data,
            showValidationErrors: false
        }); 
        
        if(data==='creditcard'){
            this.props.history.push({
                pathname:``,
                state:{
                    sourceData:data,
                    invoiceStreamID:this.props.streamInternalID,
                    invoiceStreamName:this.props.selectedMultiInvoceStreamName,
                    multiStreamDropDownArray:this.props.multiStreamDropDownArray,
                    
                },
            })
        }
    };



    writeValue = (value, path) => {
        const { paymentMethod, accountCreditCardVM, accountBankDetailVM } = this.state;
        if (paymentMethod === 'wire') {
            _.set(accountBankDetailVM, path, value);
            this.setState({ accountBankDetailVM });
        } else {
            // accountCreditCardVM.invoiceStreamIds =this.props.selectedInvoiceStreamDropDownValue;
            _.set(accountCreditCardVM, path, value);
            this.setState({ accountCreditCardVM });
        }
    };

    payNowClicked = () => {
        const { onCallback } = this.props;
        const { paymentMethod, accountCreditCardVM, accountBankDetailVM } = this.state;
        const paymentVM = paymentMethod === 'wire' ? accountBankDetailVM : accountCreditCardVM;
        const isComponentValid = this.isModelValid(paymentVM);

        if (!isComponentValid) {
            this.setState({
                showValidationErrors: true
            });
            return;
        }

        if (onCallback) {
            onCallback(paymentVM, paymentMethod);
        }
    };

    getAmounttoPayValues=()=>{
        const values =[]
        if(this.props.dueAmount!==undefined)
        {        
            const value1 = {
                id:"amount Due",
                displayName:`$${this.props.dueAmount}`,
            }
            values.push(value1)
            this.state.amountDue=this.props.dueAmount;
        }
        return values;
    }
    
    componentDidUpdate(previousprops,previousstate){
        const {checkboxEnabled,abavalid,accountNumbervalid,selectedradiobutton,amountDue,otherAmount,accountBankDetailVM}=this.state;
        
        if(this.props.accountNumber!==previousprops.accountNumber || this.props.dueAmount!==previousprops.dueAmount){
            this.setState({selectedradiobutton:""});
            this.state.otherAmount= " ";
            this.state.checkboxEnabled='';
            this.state.paymentMethod='wire';
            
            if(!_.isEmpty(accountBankDetailVM.value.bankAccountNumber)){
                _.set(accountBankDetailVM.value,'bankAccountNumber',"\n");
            }
            if(!_.isEmpty(accountBankDetailVM.value.bankAccountNumberConfirmation)){
             _.set(accountBankDetailVM.value,'bankAccountNumberConfirmation',"\n");
            }
            if(!_.isEmpty(accountBankDetailVM.value.bankABANumber)){
            _.set(accountBankDetailVM.value,'bankABANumber',"\n");
            }
        }
        if(checkboxEnabled&&abavalid&&accountNumbervalid){
            if((selectedradiobutton==="amount Due" && amountDue>0)||(selectedradiobutton==="other" && otherAmount>0))
            {
                if(this.state.continuevalid===false)
                {
                // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({continuevalid:true})
                }
            }
            else if(this.state.continuevalid===true){
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({continuevalid:false})
            }
        }else if(this.state.continuevalid===true)
        {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({continuevalid:false})
        }
        if(selectedradiobutton===""){
            
            if(this.state.amountDue>0){
                //eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    selectedradiobutton:"amount Due"
                })
                //this.state.selectedradiobutton='amount Due';
            }else{
                this.setState({
                    selectedradiobutton:"other"
                })
                //this.state.selectedradiobutton='other';
            }
            // if(this.state.amountDue<=0){
            //     // eslint-disable-next-line react/no-did-update-set-state
            //     this.setState({
            //         selectedradiobutton:"other"
            //     })
            // }
        }
    }

    setAmount = (e) => {
       
        const amount=e.target.value;
        const validated = amount.match(/^(\d*\.{0,1}\d{0,2}$)/)
        if (validated) {
            this.setState({otherAmount:(e.target.value)})
          
        }
       
    };

    getinputvalue=()=>{
        return <>$<input className={PaymentStyles.otheramountInput}
            type='number'
            name='name'
            disabled={this.state.selectedradiobutton==="amount Due"} 
            step={0.01}
            decimalPlaces={2}
            min={0} 
            value={this.state.otherAmount}
            //onChange={(e)=>{this.setState({otherAmount:(e.target.value)})}}/></>
            onChange={(e)=>{this.setAmount(e)}}/></>
    }

    

    getOthertoPayValues=()=>{
        const values =[]
        const value1 = {
            id:"other",
            displayName:this.getinputvalue(),
        }
        values.push(value1);
        
        return values;
    }

    handleradiobutton = (value) =>{ 
        this.setState({selectedradiobutton: value});
        }

    checkABA = (value) => {
        if (value) {
            let i; let n; let t;
            t = "";
            for (i = 0; i < value.length; i++) {
                const c = parseInt(value.charAt(i), 10);
                if (c >= 0 && c <= 9)
                    t += c;
            }
            if (t.length !== 9)
                return false;
            n = 0;
            for (i = 0; i < t.length; i += 3) {
                n += parseInt(t.charAt(i), 10) * 3
                    + parseInt(t.charAt(i + 1), 10) * 7
                    + parseInt(t.charAt(i + 2), 10);
            }
            if (n !== 0 && n % 10 === 0)
            {
                return true;
            }
            return false;
        } return false;
    };

    handleContinue=(e,paymentVM)=>{
        e.preventDefault();
        if(!_.isEmpty(paymentVM)){     
            if(paymentVM.value.bankAccountNumber!==paymentVM.value.bankAccountNumberConfirmation){
                this.setState({showmatchwarningMsg:true})
            }
            else{
                this.setState({showmatchwarningMsg:false})
                this.setState({
                    setreadonly:true,
                    setDropdown:'hidedropdown'
                })
            }
        }
        // eslint-disable-next-line react/no-unused-state
        this.props.history.push({
            pathname:``,
            state:{
                showHideDropDownNew:true,
            },
        })
    }

    handleValidation=(value,path)=>{
        if (path==="bankABANumber"){
            const valid = this.checkABA(value);
            this.setState({
                abavalid:valid
            })
        }
        else if(path==="bankAccountNumber"){
            if(value.length>=4){
                this.setState({
                    accountNumbervalid:true
                })
            }
            else{
                this.setState({
                    accountNumbervalid:false
                })
            }
        }
    }

    handlePayment=(e,paymentVM)=>{
        e.preventDefault();
        this.setState({isLoading:true})
        const {authHeader,history} =this.props;
        const payload=[];
        const details = {
            amountPaid:{
                currency:"usd",
                amount:0
            },
            paymentInstrument:{
                bankAccountData:{},
                paymentMethod: "webacheft"
            }
        }
        if(this.state.selectedradiobutton==="amount Due"){
            details.amountPaid.amount=this.state.amountDue
        }
        else{
            details.amountPaid.amount=this.state.otherAmount
        }
        details.paymentInstrument.bankAccountData=paymentVM.value
        details.paymentInstrument.bankAccountData.bankName= ""
        details.invoiceStreamId =this.props.selectedInvoiceStreamDropDownValue
        details.invoiceStreamName =this.props.selectedMultiInvoceStreamName
        payload.push(details);  
        // payload.push(this.props.selectedInvoiceStreamDropDownValue);
        // payload.push(this.props.selectedMultiInvoceStreamName);
        payload.push(this.props.accountNumber)
        BillingService.makeAchPayment_Ext(payload,authHeader)
            .then((res)=>{
                // eslint-disable-next-line react/no-unused-state
                if(res.length>0){
                    this.setState({payNowFlag:true});
                }
                
                history.push({

                    pathname:`/billing-summary`,
                    search:`?status=APPROVED&refNumber${res}`,
                    state:{
                        res:res,
                        message:'approved',
                        payNowFlag:this.state.payNowFlag,
                        accountNumber:this.props.accountNumber,
                        invoiceStreamID:this.props.selectedInvoiceStreamDropDownValue,
                        invoiceStreamName:this.props.selectedMultiInvoceStreamName,
                        multiStreamDropDownArray:this.props.multiStreamDropDownArray,
                    }
                })}).finally(()=>{
                this.setState({isLoading:false})
            })
       
    }

    onCanceledPayment=()=>{
        const {history,accountNumber} = this.props;
        return history.push({
            pathname:`/billing-summary`,
            state:{
            PaymentCanceled:"PaymentCanceled",
            invoiceStreamID:this.props.selectedInvoiceStreamDropDownValue
        }
            
        })
    }

    handleBack=()=>{
        this.setState({
            setreadonly:false,
            setDropdown:'showdropdown',
        })
        this.props.history.push({
            pathname:``,
            state:{
                 page:"PaymentPage",
                 showHideDropDownNew:false, 
                 multiInvoicedropDownValue:this.props.selectedInvoiceStreamDropDownValue,
                 multiStreamDropDownArray:this.props.multiStreamDropDownArray,
                //creditCardFlag:false
            },
        })
        
    }

    getTermsandConditions=()=>{
        return(
            <span>
                I have read and agree to the <Link to="/" style={{ "font-size":"1.1rem","color":"#26a9e0"}} onClick={(e)=>this.Popup(e)}>Terms and Conditions</Link>
            </span>
        )
    }

    getTermsandConditionsMsg=()=>{
        const translator = this.context;
        return(<div className={PaymentStyles.termsandconditions}>
            <span>{translator(messages.termsandConditionsText1)}</span>

            <span>{translator(messages.termsandConditionsText2)}</span>

            <span>{translator(messages.termsandConditionsText3)}</span>

            <span>{translator(messages.termsandConditionsText4)}</span>

            <span>{translator(messages.termsandConditionsText5)}</span>

        </div>)
    }

    Popup=(e)=>{
        e.preventDefault();
        const {modalContext}=this.props
        modalContext.showConfirm({
            title: messages.termandConditionsheader,
            message: this.getTermsandConditionsMsg(),
            confirmButtonText: "I Agree",
            cancelButtonText: "I Disagree"
        }).then((results) => {
            if (results === 'confirm') {
                return this.setState({checkboxEnabled:true})
            }
            return this.setState({checkboxEnabled:false})
        }, _.noop);
    }

    getpaymentOptions=()=>{
        if((this.state.amountDue<=10000) || (this.state.amountDue >10000  && this.props.grandfatherdAccount))
        {
            return [
                {
                    code: "wire",
                    name: {
                        id: "quoteandbind.views.payment-details.Bank Account",
                        defaultMessage: "Bank Account"
                    }
                },
                {
                    code: "creditcard",
                    name: {
                        id: "quoteandbind.views.payment-details.Credit Card",
                        defaultMessage: "Credit Card"
                    }
                }
            ]
        }
       
        return [
            {
                code: "wire",
                name: {
                    id: "quoteandbind.views.payment-details.Bank Account",
                    defaultMessage: "Bank Account"
                }
            }
        ]
    } 

    getCartAmount=(cartAmount)=>{
        
        // Create our number formatter.
        const formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                });

        if(cartAmount!==null)
        {
            return formatter.format(cartAmount);   
        }
         
        return formatter.format(cartAmount); 
    }

    getEnrollmentText=()=>{
        return (
            <>
                <div className={PaymentStyles.enrollmentText}>
                    {`You are about to make a payment for the account named below:`}
                </div>
                <div className={PaymentStyles.accountNumberAndName}> 
                    <div>{this.props.accountName}</div>
                    <div>{this.props.accountNumber}</div>
                    <div>{this.props.originalInvoiceStreamLength===1?'':this.props.selectedMultiInvoceStreamName}</div>
                </div>
                <br/>
            </>
        );    
    }
    
    getCreditCardFlag=(value)=>{
        this.props.history.push({
            pathname: ``,
            state: {
                creditCardFlag: value,
                invoiceStreamId:this.props.selectedInvoiceStreamDropDownValue,
                invoiceStreamName:this.props.selectedMultiInvoceStreamName
            }
        });
        this.setState({bluePayFlag:value})
    }

    render() {
        const translator = this.context;
        const {
            paymentMethod,
            accountCreditCardVM,
            accountBankDetailVM,
            showValidationErrors,
        } = this.state;
        const paymentVM = paymentMethod === 'wire' ? accountBankDetailVM : accountCreditCardVM;
        const {
            title, nextLabel, previousLabel, onCancel, isCustomFooter, isDisabled,
            isSetupPayment, hideTitle, setComponentValidation, isSelectedInvoiceAmount
        } = this.props;
        const isComponentValid = this.isModelValid(paymentVM);
        const creditCardIssuer = _.get(accountCreditCardVM.value, 'creditCardIssuer', undefined);
        const overrides = {
            '@field': {
                phoneWide: {
                    labelPosition: 'top'
                },
                
            },
            automaticPaymentMethod: {
                visible: isSetupPayment,
                value: translator(messages.bankAccountSource)
            },
            
            paymentOptions: {
                availableValues:this.getpaymentOptions(),
                value: paymentMethod,
                labelPosition: 'left',
                visible: (this.state.setDropdown==='showdropdown')&&(this.state.dropDownVisibility!=='hideSourceDropdown')
                // visible:this.getVisibilityStatus()
            },
            bankAccountContainer: {
                visible: paymentMethod === 'wire'
            },
            creditCardNumber: {
                mask: CreditCardUtil.getInputMaskForIssuerCode(creditCardIssuer)
            },
            
            payNow: {
                onClick: this.payNowClicked,
                content: translator(nextLabel) || translator(messages.paymentComponentBuyNow),
                disabled: isDisabled || isSelectedInvoiceAmount || !isComponentValid
            },
            paymentOptionsTitle: {
                content: translator(title) || translator(messages.paymentMethod),
                visible: !hideTitle
            },
            cancel: {
                visible: paymentMethod !=='creditcard',
                content: translator(previousLabel) || translator(messages.cancel)
            },
            nextbutton:{
                visible: paymentMethod !== 'creditcard' ,
                disabled:!this.state.continuevalid,
                onClick:(e)=>this.handleContinue(e,paymentVM)

            },
            buttonContainer: {
                className: cx(PaymentStyles.paymentButtonFooter, {
                    [PaymentStyles.paymentCustomFooter]: isCustomFooter
                }),
                visible:!this.state.setreadonly
            },
            cartbuttonContainer:{
                className: cx(PaymentStyles.paymentButtonFooter, {
                    [PaymentStyles.paymentCustomFooter]: isCustomFooter
                }),
                visible:this.state.setreadonly
            },
            amountPay:{
                visible:!this.state.setreadonly
            },
            accountType:{
                visible:!this.state.setreadonly
            },
            amountDue:{
                availableValues:this.getAmounttoPayValues(),
                onValueChange:this.handleradiobutton,
                value:this.state.selectedradiobutton,
                disabled:this.state.amountDue<=0,
            },
            mismatchWarning:{
                visible:this.state.showmatchwarningMsg
            },
            otherAmount:{
                availableValues:this.getOthertoPayValues(),
                onValueChange:this.handleradiobutton,
                value:this.state.selectedradiobutton
            },
            accountNumber:{
                onValueChange:(value,path)=>{_.set(paymentVM,'bankAccountNumber',value);this.handleValidation(value,path);},
                value:_.get(paymentVM,'bankAccountNumber.value'),
                visible:!this.state.setreadonly
            },
            confirmAccountNumber:{
                visible:!this.state.setreadonly
            },
            abaNumber:{
                onValueChange:(value,path)=>{_.set(paymentVM,'bankABANumber',value);this.handleValidation(value,path);},
                value:_.get(paymentVM,'bankABANumber.value'),
                visible:!this.state.setreadonly
            },
            // termscheckbox:{
            //     onValueChange:(value)=>{this.setState({checkboxEnabled:value})},
            //     value:this.state.checkboxEnabled,
            //     visible:!this.state.setreadonly && paymentMethod === 'wire'
            // },
            checkboxACH:{
                onValueChange:(value)=>{this.setState({checkboxEnabled:value})},
                value:this.state.checkboxEnabled,
                visible:!this.state.setreadonly && paymentMethod === 'wire',
                label:this.getTermsandConditions()
            },
            cartAmount:{                
                visible:this.state.setreadonly,
                value:this.state.selectedradiobutton==="amount Due"?`${this.getCartAmount(this.state.amountDue)}`:`${this.getCartAmount(this.state.otherAmount)}`
               
            },
            cartaccountType:{
                visible:this.state.setreadonly,
                //  value:_.get(paymentVM.value,'bankAccountType')
                value:_.get(paymentVM.value,'bankAccountType')==='checking'?'Checking':'Savings'
            },
            cartaccountNumber:{
                visible:this.state.setreadonly,
            },
            cartabaNumber:{
                visible:this.state.setreadonly,
            },
            paybutton:{
                onClick:(e)=>this.handlePayment(e,paymentVM)
            },
            creditlimitwarning:{
                visible:this.state.amountDue>=0 && !this.state.setreadonly && this.state.dropDownVisibility!=='hideSourceDropdown'
            },
            enrollmentMessageText:{
                content:this.getEnrollmentText()
            }
        };

        const resolvers = {
            resolveClassNameMap: PaymentStyles,
            resolveCallbackMap: {
                handlePaymentOptions: this.handlePaymentOptions,
                getAmounttoPayValues:this.getAmounttoPayValues,
                onCancel: this.onCanceledPayment,
                onBack:this.handleBack
            }
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.componentContent, paymentVM, id, path, overrides);
        };

        const { isLoading }=this.state
        if (isLoading) {
            return (
                <div>
                    <LoaderExt loaded={!isLoading}/>
                    <div className={PaymentStyles.flexdiv}>
                        <div className={PaymentStyles.maincontent}>
                            <Icon icon="mi-warning" className={PaymentStyles.msgicon} />
                            <h4>Your payment is processing.Please do not press the back button or close your browser</h4>
                        </div>
                    </div>
                </div>);
        }


        if(paymentMethod ==='creditcard')
        {
            return(
                <><ViewModelForm
                    uiProps={metadata.componentContent}
                    model={paymentVM}
                    showErrors={showValidationErrors}
                    overrideProps={overrides}
                    resolveValue={readValue}
                    onValidationChange={setComponentValidation}
                    onValueChange={this.writeValue}
                    classNameMap={resolvers.resolveClassNameMap}
                    callbackMap={resolvers.resolveCallbackMap}
                />
                    <BluePay userInfo={this.props.userInfo}
                        accountNumber={this.props.accountNumber}
                        amountDue={this.props.dueAmount} setCallback={(value) => {
                            this.setState({
                                dropDownVisibility: value
                            });
                        }}
                        accountName={this.props.accountName}
                        creditCard={(value) => this.getCreditCardFlag(value)}
                    />
                    {this.state.bluePayFlag ? (
                        <div>
                            <div className={PaymentStyles.enrollmentText}>
                                {`You are about to make a payment for the account named below:`}
                            </div>
                            <div className={PaymentStyles.accountNumberAndName}>
                                <div>{this.props.accountName}</div>
                                <div>{this.props.accountNumber}</div>
                                <div>{this.props.selectedMultiInvoceStreamName}</div>
                            </div>
                        </div>
                    ) : ('')
                    }
                </>

            
            )
        }
        return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={paymentVM}
                showErrors={showValidationErrors}
                overrideProps={overrides}
                resolveValue={readValue}
                onValidationChange={setComponentValidation}
                onValueChange={this.writeValue}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
            
            
            
        );
    }
}

export default withRouter(withValidation(withViewModelService(withAuthenticationContext(withModalContext(PaymentComponentExt)))));
